module.exports = __webpack_public_path__ + "static/img/iphone-baojia.741966d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download/iphone-baojia.png
// module id = HooU
// module chunks = 70